import { connect } from 'react-redux'
import LanguageMenu from '../components/LanguageMenu'

const mapStateToProps = (state) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LanguageMenu)



// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/containers/LanguageMenu.js